import React, { useEffect } from 'react';
import cn from 'classnames';
import ResearchTable from '../../common/ResearchTable';
import ResearchTableWrapper from './ResearchTableWrapper';
import Spinner from '@dealroadshow/uikit/core/components/Loader/Spinner';
import { dataTableStyles } from '@dealroadshow/uikit/core/components/Table/DataTable';
import EmptyMessageWithLink from '@/finsight/ui/common/components/EmptyMessageWithLink';
import URL from '@/finsight/Router/urlConstants';
import ResearchContextProvider, { useResearchContext } from '@/finsight/application/Research/ResearchContext';
import { useParentPageContext } from '@/finsight/application/ParentPageContext';
import DocumentGroupContextProvider from '@/finsight/application/Research/DocumentGroupContext';
import { useDictionariesContext } from '@/finsight/application/Dictionaries/DictionariesContext';
import { makeEmptyGroupIds } from '@/finsight/application/actions/research/helpers';
import Paginator from './PaginatorContainer';

import spacesStyles from '@dealroadshow/uikit/core/styles/helpers/spaces.scss';
import researchTableStyles from '@/finsight/ui/components/research/common/ResearchTable/researchTable.scss';
import cardStyles from '@dealroadshow/uikit/core/styles/card.scss';

const ResearchTile = () => {
  const {
    researchData: {
      collection,
      isFetching,
    },
    isHideModule,
    resetResearch,
  } = useResearchContext();
  useEffect(() => resetResearch, [resetResearch]);

  if (isHideModule) {
    return null;
  }

  return (
    <div className={ cn(spacesStyles.mtl, spacesStyles.mbn, cardStyles.cardContainer) }>
      <ResearchTableWrapper>
        { (isFetching && !collection.length) && (
          <Spinner overlay />
        ) }
        <div className={ cn(dataTableStyles.dataTableContainer, researchTableStyles.dataTableContainer) }>
          { !!collection.length && <ResearchTable /> }
          <Paginator dataTest="researchTableWrapperPaginator" />
          { (!collection.length && !isFetching) && (
            <div className={ researchTableStyles.emptyMessage }>
              <EmptyMessageWithLink
                text="Explore all other"
                linkTo={ URL.NRSRO_RESEARCH_REPORTS }
                linkTitle="research"
              />
            </div>
          ) }
        </div>
      </ResearchTableWrapper>
    </div>
  );
};

export default () => {
  const { research } = useParentPageContext();
  const { researchDocumentGroupList } = useDictionariesContext();

  return (
    <DocumentGroupContextProvider initial={ {
      researchDocumentGroupList,
      initialGroup: research.includedDocumentGroup,
      emptyGroupIds: makeEmptyGroupIds(research.response),
    } }
    >
      <ResearchContextProvider data={ research }>
        <ResearchTile />
      </ResearchContextProvider>
    </DocumentGroupContextProvider>
  );
};
